import { CONTEXT_PROPS } from '../../types/ContextProps';
import { getKeys } from '../../adapters/utils';
import { SD_STATUS } from '../../consts';
import { getRawValue, get } from '../../utils/get';
import { ITEM_TYPES } from '../../types/ItemTypes';
import { resolveItemTypeMultilingualUrl } from '../../utils/resolve-item-type-multilingual-url';
export var IDs = {
    PAGE_NAME: 'page.name',
    PAGE_URL: 'page.url',
    TOTAL_PLANS: 'pricing-plans.total-plans',
};
var SchemaTypes = {};
var userVisible = [IDs.PAGE_NAME, IDs.PAGE_URL, IDs.TOTAL_PLANS];
var userVisibleSdOnly = [];
export default {
    IDs: IDs,
    SchemaTypes: SchemaTypes,
    getData: function (item) {
        var _a;
        var plans = getRawValue(item, 'plans') || [];
        return _a = {},
            _a[IDs.PAGE_URL] = resolveItemTypeMultilingualUrl(ITEM_TYPES.PRICING_PLANS, item, get(item, 'pageUrl')),
            _a[IDs.PAGE_NAME] = get(item, "context.".concat(CONTEXT_PROPS.PAGE_NAME)),
            _a[IDs.TOTAL_PLANS] = plans.length,
            _a;
    },
    getSdStatus: function () { return SD_STATUS.DOES_NOT_EXIST; },
    getLegacySeoBlob: function () { },
    getSlug: function () { return ''; },
    updateItemDataWithSlug: function (item) { return item; },
    getKeys: function () { return getKeys(IDs, userVisible); },
    getSdKeys: function () { return getKeys(IDs, userVisibleSdOnly); },
};
